import React from 'react';
import { Col, Checkbox, Row, Body, styled } from '@teko/ds-desktop';
import { SellerCard } from '@teko/teko-ecommerce';
import { t } from '../../i18n.es.js';

const CartSeller = ({
  name,
  imageUrl = "",
  slogan,
  checked = false,
  indeterminate = false,
  onCheck,
  isAvatarHidden = false,
  disabled = false
}) => {
  return /* @__PURE__ */ React.createElement(Wrapper, {
    justify: "space-between",
    align: "middle"
  }, /* @__PURE__ */ React.createElement(Col, {
    flex: "4%"
  }, /* @__PURE__ */ React.createElement(Checkbox, {
    checked,
    partSelected: indeterminate,
    onChange: () => onCheck(!checked),
    className: "att-uncheck-all-product",
    disabled
  })), /* @__PURE__ */ React.createElement(Col, {
    flex: "96%"
  }, /* @__PURE__ */ React.createElement(Row, {
    justify: "space-between",
    align: "middle"
  }, /* @__PURE__ */ React.createElement(Col, {
    span: 6
  }, /* @__PURE__ */ React.createElement(SellerCard, {
    name,
    slogan,
    avatar: { src: imageUrl || "" },
    isAvatarHidden
  })), /* @__PURE__ */ React.createElement(PriceColumn, {
    span: 2,
    paddingRight: "s16"
  }, /* @__PURE__ */ React.createElement(Body, null, t("\u0110\u01A1n gi\xE1"))), /* @__PURE__ */ React.createElement(QuantityColumn, {
    span: 2
  }, /* @__PURE__ */ React.createElement(Body, null, t("S\u1ED1 l\u01B0\u1EE3ng"))), /* @__PURE__ */ React.createElement(PriceColumn, {
    span: 2
  }, /* @__PURE__ */ React.createElement(Body, null, t("Th\xE0nh ti\u1EC1n"))))));
};
const PriceColumn = styled(Col)`
  text-align: right;
`;
const QuantityColumn = styled(Col)`
  text-align: center;
`;
const Wrapper = styled(Row)`
  padding: 1rem;
  border-bottom: 1px solid #eaeaea;
`;

export { CartSeller };
